import React, { Component, Fragment } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import RefreshToken from "../../redux/actions/RefreshToken";

import KcHeader from "../../components/template/KcHeader";
import KcNavigation from "../../components/template/KcNavigation";
import KcFooter from "../../components/template/KcFooter";
import { SET_ERROR_STATE, RESET_STATUS_STATE } from "../constants/actionTypes";
import Notif, { readNotif } from "../../redux/actions/Notif";
import Loading from "../../components/molecules/Loading";
import InformationText from "../../components/molecules/InformationText";
import { ToastsStore, ToastsContainer } from "react-toasts";
import { GProf } from "../../config/api";
import Profil from "../../redux/actions/Profil";

const CheckAuth = (ChildComponent) => {
	class ParentComponent extends Component {
		constructor(props) {
			super(props);

			this.state = {
				ClientID: null,
				title: "",
				isAlready: false,
				breadcrumb: [],
			};
		}

		componentDidMount = () => {
			// this.props.ResetStatusState()
			this.props.RefreshToken((ClientID) => {
				if (ClientID) {
					this.props.GetNotif(ClientID);
					this.props.GetProfil(ClientID);
					this.setState({
						isAlready: true,
						ClientID: ClientID,
					});
				}
			}, true);

			console.log("Mounting HOC");
		};

		setTitle = ({ title, breadcrumb }) => {
			document.title = `${title} - KlikCair - Peminjam`;

			this.setState({
				title: title,
				breadcrumb: breadcrumb,
			});
		};

		setReadNotif = (id, status) => {
			status
				? this.props.history.push(`/notifikasi/detil/${id}`)
				: this.props.RefreshToken((ClientID) => {
						this.props.ReadNotif(ClientID, id);
				  }, true);
		};

		render() {
			let displayPage;
			const listPropsToChild = {
				...this.props,
				...this.state,
				setReadNotif: this.setReadNotif,
				setTitlePage: this.setTitle,
				resetState: this.props.ResetStatusState,
			};

			if (this.props.isLogin) {
				displayPage = (
					<div className="wrapper">
						<KcHeader {...listPropsToChild} />
						<KcNavigation {...listPropsToChild} />
						<div className="content-wrapper">
							<h1 className="title-page">{this.state.title}</h1>
							<ul className="kc-breadcrumb">
								{this.state.breadcrumb.map(({ name, url, status }, index) => {
									let attr;
									status ? (attr = { className: "aktif" }) : (attr = { href: url });
									return (
										<li key={index}>
											{" "}
											<a {...attr}>{name}</a>{" "}
										</li>
									);
								})}
							</ul>

							<section className="kc-content">{!this.state.isAlready ? <Loading /> : <ChildComponent {...listPropsToChild} />}</section>
						</div>
						<KcFooter />
					</div>
				);
			} else {
				displayPage = <Redirect to="/login" />;
			}

			return (
				<Fragment>
					<ToastsContainer store={ToastsStore} />
					{displayPage}
				</Fragment>
			);
		}
	}

	const mapStateToProps = (state) => {
		return {
			status: state.statusState,
			isLogin: state.statusLogin.login,
			notif: state.notifState,
			profile: state.profileState,
		};
	};

	const mapDispatchToProps = (dispatch) => {
		return {
			RefreshToken: (cb, isPageLoading) => {
				dispatch(RefreshToken(cb, isPageLoading));
			},
			ResetStatusState: () => {
				dispatch({ type: RESET_STATUS_STATE });
			},
			SetError: (msgErr) => {
				dispatch({ type: SET_ERROR_STATE, payload: msgErr });
			},
			GetNotif: (ClientID) => {
				dispatch(Notif(ClientID));
			},
			GetProfil: (ClientID) => {
				dispatch(Profil(ClientID));
			},
			ReadNotif: (ClientID, NotifID) => {
				dispatch(readNotif(ClientID, NotifID));
			},
		};
	};

	return connect(mapStateToProps, mapDispatchToProps)(ParentComponent);
};

export default CheckAuth;
